$( document ).ready(function($) { 
  var data = '';
  var cat_first = true;
  var items = "";
  var item = false;
  var category = "";
  var addedClasses = "";
  var section_content = '<div class="roc-wrapper"><ul class="ui-accordion-content ui-corner-bottom ui-helper-reset ui-widget-content ui-accordion-content-active" id="ui-id-4" aria-labelledby="ui-id-3" role="tabpanel" aria-hidden="false" style="display: block;">';
  jQuery.each(catorder, function() {
    
    //console.log(this.type)
    switch(this.type) {
      case 'category':
    	item = '<li><a class="bare-link" href="/collections/'+ this.handle +'">' +this.label+'</a></li>';
      break;
      case 'section':
        if (cat_first){
        	category = '<ul class="accordion first-cat-accordion"  style="border-bottom: solid 1px #dbd9d6;"><h5>'+this.title+'</h5><ul>';
          	cat_first = false;
            item = false;
          	
        } else {
          	category = '</ul></ul><ul class="accordion"  style="border-bottom: solid 1px #dbd9d6;"><h5>'+this.title+'</h5><ul>';
         	items = "";
          	item = false;
          	cat_first = false;
          
        }
      break;
      case 'customlink':
      	
        var addedID = '';
        if (this.title.toLowerCase().includes("view all")){
          addedID = 'id="all-collections-link"';
          addedClasses = "";
        } else {
        	addedClasses = "";
        }
      item = '<li '+addedID+'><a class="bare-link '+addedClasses+'" href="'+ this.url +'">' +this.title+'</a></li>';
      break;
      default:
      // code block
	}
    if (item){
   		 data += item;
    } else {
    
    	data += category 
    }
   
     
  
  })
  data += '</ul></div>';
  //console.log(data);
  $('#roc-cats').html(data);
       if ($(window).width() < 769) {
         var x = 0;
          $("#roc-cats .accordion").accordion({
                collapsible: true,
                active: 0,
                heightStyle: "content",
                create: function( event, ui ) {
                  if (x == 0){
                   // $("#roc-cats .accordion.first-cat-accordion h5#ui-id-1").trigger("click");
                  }
                  x++
                  //$("#roc-cats .accordion.first-cat-accordion h5#ui-id-1").trigger("click");
                },
                icons: {
                  "header": "ui-icon-plus",
                  "activeHeader": "ui-icon-minus"
                }
          });
         $("#skin-type-filter").accordion({ 
                collapsible: true,
                active: false,
                heightStyle: "content",
                icons: {
                  "header": "ui-icon-plus",
                  "activeHeader": "ui-icon-minus"
                }
        });
     } else {
  $("#roc-cats .accordion, #skin-type-filter").accordion({
          collapsible: true,
          active: 0,
          heightStyle: "content",
          icons: {
            "header": "ui-icon-plus",
            "activeHeader": "ui-icon-minus"
          }
        });
        }
})